'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _ModalWindow2 = require('./ModalWindow');

var _ModalWindow3 = _interopRequireDefault(_ModalWindow2);

var ConfirmWindow = (function (_ModalWindow) {
	_inherits(ConfirmWindow, _ModalWindow);

	function ConfirmWindow(title, text, style) {
		_classCallCheck(this, ConfirmWindow);

		_ModalWindow.call(this, title, text, null, style);
		this.lang = {
			ok: 'OK',
			cancel: 'Storno'
		};
	}

	ConfirmWindow.prototype.handleHide = function handleHide(callback) {
		this.hide();
		if (callback) {
			callback();
		}
	};

	ConfirmWindow.prototype.show = function show(dispatch, okCallback, cancelCallback) {
		var _this = this;

		var modal = _react2['default'].createElement(
			_reactBootstrap.Modal,
			{ animation: true, show: true, onHide: function () {
					return _this.handleHide(cancelCallback);
				}, bsStyle: this.style },
			_react2['default'].createElement(
				_reactBootstrap.Modal.Header,
				{ closeButton: true },
				_react2['default'].createElement(
					_reactBootstrap.Modal.Title,
					null,
					this.title
				)
			),
			_react2['default'].createElement(
				_reactBootstrap.Modal.Body,
				null,
				_react2['default'].createElement(
					'div',
					{ style: { padding: '20px 5px' } },
					this.text
				)
			),
			_react2['default'].createElement(
				_reactBootstrap.Modal.Footer,
				null,
				_react2['default'].createElement(
					_reactBootstrap.Button,
					{ onClick: function () {
							return _this.handleHide(cancelCallback);
						}, bsStyle: 'link' },
					this.lang.cancel
				),
				_react2['default'].createElement(
					_reactBootstrap.Button,
					{ onClick: function () {
							return _this.handleHide(okCallback);
						}, bsStyle: 'primary' },
					this.lang.ok
				)
			)
		);
		this.dispatch(dispatch, modal);
	};

	return ConfirmWindow;
})(_ModalWindow3['default']);

exports['default'] = ConfirmWindow;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-modal/src/ConfirmWindow.js
 ** module id = 1049
 ** module chunks = 1
 **/